export class HttpError extends Error {
  public readonly status: number;
  public readonly body?: unknown;

  constructor(status: number, message: string, body?: unknown) {
    super(message);
    this.status = status;
    this.body = body;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = 'HttpError';
  }
}

/**
 * Testa o status de um erro vindo do `api()`.
 *
 * Existe para substituir a checagem por regex na mensagem, que nunca funcionou:
 * o `api()` sobrescreve a mensagem pela `friendlyMessage` da API e descarta o
 * codigo, entao `/404/.test(error.message)` dava sempre falso e o erro escapava
 * como 500.
 */
export const isHttpStatus = (error: unknown, status: number): error is HttpError =>
  error instanceof HttpError && error.status === status;
